import React, { useState, useEffect } from "react";
import classes from "./andHomePage.module.css";
import HeroSection from "./HeroSection";
import CategorySection from "./CategorySection";
import PrizeSection from "./PrizeSection";
import ContestSection from "./ContestSection";
import WinnersSection from "./WinnersSection";

const ANDHomePage = () => {
  const [contests, setContests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Simulating fetch data from API
  useEffect(() => {
    // In a real app, replace with actual API call
    setTimeout(() => {
      setContests([
        {
          id: 1,
          title: "Weekly Singing Challenge",
          description: "Show your vocal talent and win amazing prizes!",
          endDate: "2025-05-22",
          participants: 124,
          category: "singing",
        },
        {
          id: 2,
          title: "Dance Competition",
          description: "Express yourself through movement and rhythm!",
          endDate: "2025-05-20",
          participants: 98,
          category: "dancing",
        },
        {
          id: 3,
          title: "Photography Masters",
          description: "Capture moments that tell stories!",
          endDate: "2025-05-25",
          participants: 156,
          category: "photography",
        },
        {
          id: 4,
          title: "Video Editing Challenge",
          description: "Showcase your editing skills and creativity!",
          endDate: "2025-05-23",
          participants: 83,
          category: "video",
        },
        {
          id: 5,
          title: "Magic & Illusion Contest",
          description: "Amaze the audience with your magical talents!",
          endDate: "2025-05-21",
          participants: 67,
          category: "magic",
        },
      ]);
      setLoading(false);
    }, 1000);
  }, []);

  const categories = [
    { id: 1, name: "Singing", icon: "🎤", color: "#ff7b25" },
    { id: 2, name: "Dancing", icon: "💃", color: "#ff1e6c" },
    { id: 3, name: "Photography", icon: "📸", color: "#3a86ff" },
    { id: 4, name: "Video Editing", icon: "🎬", color: "#8338ec" },
    { id: 5, name: "Magic", icon: "✨", color: "#fb5607" },
  ];

  const prizes = [
    {
      place: "1st Place",
      reward: "Amazon Gift Card + Artist Spotlight (7 Days)",
      icon: "🏆",
    },
    {
      place: "2nd Place",
      reward: "Amazon Gift Card + Artist Spotlight (5 Days)",
      icon: "🥈",
    },
    {
      place: "3rd Place",
      reward: "Amazon Gift Card + Artist Spotlight (3 Days)",
      icon: "🥉",
    },
    {
      place: "Weekly Highlights",
      reward: "Featured on our Social Media Platforms",
      icon: "🌟",
    },
  ];

  return (
    <div className={classes.app}>
      <main className={classes.mainContent}>
        <HeroSection />
        <div className={classes.container}>
          <CategorySection categories={categories} />
          <PrizeSection prizes={prizes} />
          <ContestSection contests={contests} loading={loading} />
          <WinnersSection />
        </div>
      </main>
    </div>
  );
};

export default ANDHomePage;
